import React from "react";
import styleClasses from "../../../../containers/order/order.module.scss";
import { REACT_APP_CLOUD_FRONT } from "../../../../constants";
// import StarIcon from '@material-ui/icons/Star';
import { useLocation } from "react-router";
import { toFixedNumber } from "../../../../priceCalculation/helper";
import { ISizeCard } from "../../../../models/order";
import { useAppSelector } from "../../../../redux/store/store";
import { persistZero } from "../../../../helpers/helperMethods";
import useCheckMobileScreen from "../../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../../hooks/useIsDesignV2";

const SizeCard: React.FC<ISizeCard> = (props) => {
  const { id, title, calories, price, onChange, selected, redeemPoints, selectedToRedeem, handleRedeemSize, additionalPrice, showRedeemButton, disabled, baseCalories } = props;
  const location = useLocation();
  let { search } = location;
  const query = new URLSearchParams(search);
  const isThisMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2()
  const order = useAppSelector((state: any) => state.itemCustomization);
  const isRedeemed = query.get("redeem");
  const starIconStyle = {
    color: selectedToRedeem ? 'white' : 'black'
  }
  
  const titleInUpperCase = id ? id?.toUpperCase() : title?.toUpperCase()

  // const isSizeSelected = order?.size ? false : true

  const displayPrice = () => {
    let itemPrice = 0;
    if(selected){
      itemPrice = toFixedNumber(price + additionalPrice)
    }else{
      itemPrice = price
    }
    return itemPrice
  }

  const displayCalories = () => {
    if(selected){
      return calories || 0
    }else{
      return baseCalories || 0
    }
  }

  return (
    <>
      {redeemPoints ?
        <div className={`${styleClasses.item_selector} flex-fill ${styleClasses.redeemPoints}`}>
          <input
            className={styleClasses.display_none}
            type="radio"
            id={titleInUpperCase}
            data-testid={titleInUpperCase}
            name="radio-group"
            onChange={onChange}
            checked={selected}
          />
          <label
            htmlFor={titleInUpperCase}
            className={`${styleClasses.optional_selector} f-s18 font-Vcf w-100 shadow-box optional-selector ${isDesignV2 && "optional-selector_mobile_designv2"} ${(selected && 'black-border')} ${(selectedToRedeem && " bg-clr-highland-green clr-sec-white")}`}
          >
            <span className={!selectedToRedeem && "clr-dark-blue"}>{title}</span>
            <br />
            {/* <span className="d-flex align-items-center justify-content-center f-s16"><span className="d-flex me-1"><StarIcon style={starIconStyle} className='img-fluid' /></span> FREE</span> */}
            <span className="font-rale f-s13">
            {displayCalories() > 0 ? `${displayCalories()} Calorie` : `Calories Vary`} 
            </span>
          </label>
          {
            showRedeemButton &&
            <button type="button" className={`${styleClasses.redeem_selector_btn} btn btn-large green mb-2 mb-sm-4 p-2 f-s11`}><span className="d-flex me-2"><img src={`${REACT_APP_CLOUD_FRONT}/images/icons/redeem-star.svg`} alt="redeem star" className="img-fluid" /></span> REWARD AVAILABLE IN CART!</button>
          }
        </div>
        :
        <div className={`${styleClasses.item_selector} flex-fill item-selector ${disabled && 'item-disabled'}`} data-testid={`${titleInUpperCase}-size-div`}>
          <input
            type="radio"
            id={titleInUpperCase}
            data-testid={titleInUpperCase}
            name="radio-group"
            onChange={onChange}
            checked={selected}
            onClick={(event) => {
              selected && onChange(event, true)
            }}
          />
          <label
            htmlFor={titleInUpperCase}
            className={`${styleClasses.optional_selector} f-s18 font-Vcf w-100 shadow-box optional-selector ${isDesignV2 && "optional-selector_mobile_designv2"} size-selector ${props.isSize ? 'border-size-select' : ''}`}
            data-testid={`${titleInUpperCase}-label`}
          >
            <span>{title} </span>
            <br />
            <span className={`${isDesignV2 && "font-Visby-cf" }`} style={{color: displayPrice() > price ? 'darkred' : ''}} data-testid="sizePriceTag">${persistZero(displayPrice())}</span>
            <br />
            <span className={`font-rale clr-text-grey f-s13 ${isDesignV2 ? 'text-lowercase' : 'text-capitalize'}`}>
              {displayCalories() > 0 ? `${displayCalories()} ${isDesignV2 ? "cal" : "Calories"}` : `Calories Vary`} 
            </span>
          </label>
          {
            showRedeemButton &&
            <button type="button" className={`${styleClasses.redeem_selector_btn} btn btn-large green mb-2 mb-sm-4 p-2 f-s11`}><span className="d-flex me-2"><img src={`${REACT_APP_CLOUD_FRONT}/images/icons/redeem-star.svg`} alt="redeem star" className="img-fluid" /></span> REWARD AVAILABLE IN CART!</button>
          }
        </div>
      }
    </>

  );
};

export default SizeCard;
